import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MiroLogoDark = function MiroLogoDark(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 700 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 256 : _ref$height,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
      width: width,
      height: height,
      viewBox: "0 0 876 320",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, rest), {}, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M663.38 163.15V233.918H692.37V167.489C692.37 137.903 732.643 137.855 732.643 137.855V109.063C732.643 109.063 721.383 109.564 712.486 111.566C687.258 117.24 663.38 129.685 663.38 163.15Z",
        fill: "var(--colors-black)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M444.846 107.632C456.139 107.632 470.25 114.021 477.932 125.259C485.887 115.039 498.968 108.141 515.131 107.879C535.663 107.616 561.051 120.395 561.051 158.723V233.83H532.054V158.723C532.054 145.945 522.814 136.758 508.982 136.758C495.15 136.758 485.902 145.945 485.902 158.723V233.83H456.913V158.723C456.913 145.945 447.681 136.758 433.834 136.758C419.986 136.758 410.491 145.945 410.491 158.723V233.83H380V111.439H410.491V123.733C418.708 113.775 430.751 107.632 444.862 107.632H444.846Z",
        fill: "var(--colors-black)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M627.716 112.997V233.919H598.231V112.997H627.716Z",
        fill: "var(--colors-black)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M612.97 93.7575C622.06 93.7575 629.43 86.4245 629.43 77.3787C629.43 68.333 622.06 61 612.97 61C603.88 61 596.511 68.333 596.511 77.3787C596.511 86.4245 603.88 93.7575 612.97 93.7575Z",
        fill: "var(--colors-black)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M811.369 107.37C775.672 107.37 746.738 136.162 746.738 171.685C746.738 207.208 775.672 236 811.369 236C847.067 236 876 207.208 876 171.685C876 136.162 847.067 107.37 811.369 107.37ZM811.369 207.081C791.165 207.081 774.777 190.782 774.777 170.668C774.777 150.554 791.157 134.255 811.369 134.255C831.582 134.255 847.961 150.554 847.961 170.668C847.961 190.782 831.582 207.081 811.369 207.081Z",
        fill: "var(--colors-black)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0 80C0 35.8172 35.8172 0 80 0H240C284.183 0 320 35.8172 320 80V240C320 284.183 284.183 320 240 320H80C35.8172 320 0 284.183 0 240V80Z",
        fill: "var(--colors-miro-yellow)"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M212.744 61H183.695L207.902 103.532L154.646 61H125.598L152.226 112.985L96.5488 61H67.5L96.5488 127.171L67.5 259.5H96.5488L152.226 117.718L125.598 259.5H154.646L207.902 108.265L183.695 259.5H212.744L266 94.0793L212.744 61Z",
        fill: "var(--colors-black)"
      })]
    }))
  });
};